export class AppError extends Error {
    context;
    constructor(message, context = {}) {
        super(message);
        this.context = context;
        this.name = this.constructor.name;
    }
}
